import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { IEvent } from '../../store/events/interfaces'

export const ExternalRegistrationModal = (props: {
  event: IEvent
  show: boolean
  onHide: () => void
}) => {
  const { event, show, onHide } = props

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      renderBackdrop={true}
    >
      <Modal.Header closeButton closeLabel={'Modal schließen'}>
        <Modal.Title>
          <strong>Externe Anmeldung</strong>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p dangerouslySetInnerHTML={{ __html: event.external_registration_description_html }}></p>
      </Modal.Body>
      <Modal.Footer>
        {event.external_registration_link && (
          <Button
            variant="primary"
            onClick={() => window.open(event.external_registration_link, '_blank')}
          >
            Zur externen Anmeldung
          </Button>
        )}
        <Button variant="secondary" onClick={onHide}>
          Schließen
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
